import { Box, VStack } from "@chakra-ui/react";
import { Paragraph01, Paragraph02 } from "~/components/Texts";
import { FiTruck, FiCheckCircle, FiShoppingBag } from "react-icons/fi";
import { CgCreditCard } from "react-icons/cg";
import Stepper from "~/components/Stepper";
import { useTheme } from "@chakra-ui/react";

export default function Status(props) {
  const { order } = props;
  const chakraTheme = useTheme();

  const currentStep = () => {
    switch (order.status) {
      case "new":
        return 1;
      case "processing":
        if (order.payment.status === "paid") return 3;
        else return 2;
      case "completed":
        return 5;
      default:
        return 0;
    }
  };

  const StatusInWords = () => {
    // New order
    if (order.status === "new")
      return (
        <Paragraph01>
          <b>Tu orden fue recibida</b>
        </Paragraph01>
      );

    // Order being processed
    if (order.status === "processing") {
      if (order.payment.status === "paid") {
        switch (order.shipping.status) {
          case "pending":
            return (
              <Paragraph01>
                <b>Envío pendiente</b>
              </Paragraph01>
            );
          case "delayed":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.warning}>
                <b>Envío demorado</b>
              </Paragraph01>
            );
          case "sent":
            return (
              <Paragraph01>
                <b>Tu pedido está en camino</b>
              </Paragraph01>
            );
          case "delivered":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.positive}>
                <b>Tu pedido fue entregado</b>
              </Paragraph01>
            );
          case "returned":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.warning}>
                <b>El pedido fue devuelto</b>
              </Paragraph01>
            );
          case "canceled":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.negative}>
                <b>El envío fue cancelado</b>
              </Paragraph01>
            );
        }
      } else {
        switch (order.payment.status) {
          case "paid":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.positive}>
                <b>El pago fue recibido</b>
              </Paragraph01>
            );
          case "pending":
            return (
              <Paragraph01>
                <b>El pago aún no fue confirmado</b>
              </Paragraph01>
            );
          case "refunded":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.warning}>
                <b>El pago devuelto</b>
              </Paragraph01>
            );
          case "declined":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.warning}>
                <b>El pago fue rechazado</b>
              </Paragraph01>
            );
          case "canceled":
            return (
              <Paragraph01 textColor={chakraTheme.colors.feel.negative}>
                <b>Pago cancelado</b>
              </Paragraph01>
            );
        }
      }
    }

    // New order
    if (order.status === "completed")
      return (
        <Paragraph01 textColor={chakraTheme.colors.feel.positive}>
          <b>Tu compra fue completada, ¡que la disfrutes!</b>
        </Paragraph01>
      );

    // New order
    if (order.status === "returned")
      return (
        <Paragraph01 textColor={chakraTheme.colors.feel.warning}>
          <b>Tu compra fue devuelta</b>
        </Paragraph01>
      );

    // New order
    if (order.status === "canceled")
      return (
        <Paragraph01 textColor={chakraTheme.colors.feel.negative}>
          <b>Tu compra fue cancelada</b>
        </Paragraph01>
      );

    // Handle unknown state
    return (
      <Paragraph02 textColor={chakraTheme.colors.feel.warning}>
        <b>Ponte en contacto para más información.</b>
      </Paragraph02>
    );
  };

  return (
    <VStack w="100%">
      <Box w="100%" maxW="600px" p="8">
        <Stepper direction="row" currentStep={currentStep()}>
          <FiShoppingBag />
          <CgCreditCard />
          <FiTruck />
          <FiCheckCircle />
        </Stepper>
      </Box>
      <StatusInWords />
    </VStack>
  );
}
